<template>
  <div>
    <headers ref="headers" />

    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/forum/index">个人中心</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <div class="menuList">
        <!-- 顶部装饰卡片: 个人中心 -->
        <div class="top-card decoration-only">
          <div class="icon-box">
            <i class="el-icon-user-solid"></i>
          </div>
          <div class="card-label">个人中心</div>
        </div>

        <!-- 菜单列表 -->
        <div class="menu-items">
          <div
            v-for="item in visibleMenuList"
            :key="item.key"
            @click="changeMenu(item.key)"
            :class="['menuItem', { active: activeMenu === item.key }]"
          >
            <i :class="menuIcons[item.key] || 'el-icon-menu'"></i>
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>
      <div class="contentR">
        <div
          class="uploadPwd"
          v-if="activeMenu === MY_MENU.PROFILE"
          @click="uploadPwd"
        >
          修改密码
        </div>
        <div
          class="loginOut"
          v-if="activeMenu === MY_MENU.PROFILE"
          @click="loginOut"
        >
          退出登录
        </div>
        <div class="userInfo" v-if="activeMenu === MY_MENU.PROFILE">
          <div
            class="avatar"
            @mouseenter="handleMouseEnter()"
            @mouseleave="handleMouseOut()"
          >
            <img
              :src="
                user.avatarUrl
                  ? user.avatarUrl
                  : require('@/assets/images/dfavatar.png')
              "
              alt=""
            />
            <div
              class="userMask"
              :style="{ display: textShow ? 'block' : 'none' }"
            >
              修改头像
            </div>
            <div class="FormImgUpload">
              <FormImgUpload
                :url="headPortrait"
                @upload="upload"
                :limit="1"
                :maxSize="5"
                accept="image/jpeg,image/png,image/jpg"
                :multiple="true"
              />
            </div>
          </div>

          <div class="nameBox">
            <div class="name">
              {{ user.username }}
              <div :title="user.post">{{ user.post }}</div>
            </div>
            <div class="tel">{{ user.phone }}</div>
          </div>
          <!-- 等级图标、授权到期日期 -->
          <div
            v-if="user.type == 1 && equityLevelList.length"
            class="equityLevelList"
          >
            <div
              v-for="(item, index) in equityLevelList"
              :key="index"
              class="equityLevelItem"
            >
              <div class="equityLevelIconCol">
                <div
                  class="equityLevelIconWrap"
                  :class="{
                    'equityLevelIconWrap--expired':
                      getContractExpireStatus(item) === 'expired',
                  }"
                >
                  <img
                    v-if="lenum[item.equityClassifyName]"
                    class="equityLevelIcon"
                    :src="lenum[item.equityClassifyName]"
                    :alt="item.equityClassifyName"
                  />
                  <span v-else class="equityLevelIconText">{{
                    item.equityClassifyName
                  }}</span>
                </div>
              </div>
              <div class="equityLevelInfo">
                <div class="equityLevelDate">
                  授权到期日期：<span class="equityLevelDateVal">{{
                    formatExpireDate(item.endTime)
                  }}</span>
                </div>
                <div
                  v-if="getContractExpireStatus(item) === 'soon'"
                  class="equityLevelWarn"
                >
                  <span class="equityLevelWarnText"
                    >协议即将到期，请续签协议</span
                  >
                  <el-button
                    class="equityRenewBtn"
                    size="small"
                    @click="onRenewContract(item)"
                    >续签协议</el-button
                  >
                </div>
                <div
                  v-else-if="getContractExpireStatus(item) === 'expired'"
                  class="equityLevelWarn"
                >
                  <span class="equityLevelWarnText expired"
                    >协议已到期，请续签协议</span
                  >
                  <el-button
                    class="equityRenewBtn"
                    size="small"
                    @click="onRenewContract(item)"
                    >续签协议</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- 学习时间 -->
          <div class="scroll">
            <div class="scrollBox">
              <template v-if="formatTime(user.todayStudyTime, 1)">
                <span class="num">{{
                  formatTime(user.todayStudyTime, 1)
                }}</span>
                <span class="numTips" style="margin-right: 2px">h</span>
              </template>

              <span class="num">{{ formatTime(user.todayStudyTime, 2) }}</span>
              <span class="numTips">min</span>
            </div>
            <div class="scrollDay">今日学习</div>
          </div>
          <div class="scroll">
            <div class="scrollBox">
              <template v-if="formatTime(user.totalStudyTime, 1)">
                <span class="num">{{
                  formatTime(user.totalStudyTime, 1)
                }}</span>
                <span class="numTips" style="margin-right: 2px">h</span>
              </template>
              <span class="num">{{ formatTime(user.totalStudyTime, 2) }}</span>
              <span class="numTips">min</span>
            </div>
            <div class="scrollDay">累计学习</div>
          </div>

          <div
            v-if="
              user.state === 2 ||
              (user.state > 1 && user.state !== 2 && user.showMaterialMenu)
            "
            class="ks scroll"
            @click="onClick"
          >
            <img src="@/assets/images/jxks.png" alt="" />
            <div>{{ user.state === 2 ? "结业考试" : "物料申请" }}</div>
          </div>
        </div>

        <div class="line mt-30" v-if="activeMenu === MY_MENU.PROFILE"></div>

        <!-- <div class="card2" v-else-if="activeMenu === MY_MENU.COMPANY">
          <div class="card2Name">上海良信电器股份有限公司</div>
          <div class="dateBox">
            <div>良信股份</div>
          </div>

          <div class="card2Right"></div>
        </div> -->
        <!-- 企业信息 -->
        <company-info-form
          v-if="activeMenu === MY_MENU.COMPANY"
          :company="company"
          :is-completed="isCompleted"
          :is-edit="isEditForm"
          @submit="onCompanyFormSubmit"
        />
        <!-- 业绩信息 -->
        <performance-info
          v-if="activeMenu === MY_MENU.PERFORMANCE"
          :company="company"
          @rebate-confirmed="onRebateConfirmed"
        />
        <!-- 授权协议 -->
        <contract-management
          v-if="activeMenu === MY_MENU.CONTRACT"
          :company="company"
          @renew-contract="onContractRenew"
        />

        <!-- 我的盟友 -->
        <my-allies v-if="activeMenu === MY_MENU.ALLIES" :company="company" />

        <!-- License账号申请 -->
        <license-account-apply
          v-if="activeMenu === MY_MENU.LICENSE_APPLY"
          :company="company"
          @submit="onLicenseApplySubmit"
        />
        <!-- 授权证书 -->
        <template v-if="activeMenu === MY_MENU.CERTIFICATE">
          <div class="card3">
            <div class="card3Tit">授权证书</div>
            <div class="card3Box">
              <div
                class="card3Item"
                v-for="(item, index) in company.equityClassifyList"
                :key="index"
              >
                <img :src="item.certImage" v-if="item.certImage" />
                <div
                  class="card3ItemBtn"
                  @click="downloadImage(item.certImage)"
                  v-if="item.certImage"
                >
                  下载证书
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- 授权软件激活码 -->
        <template v-if="activeMenu === MY_MENU.LICENSE">
          <div class="card4Tit">授权软件激活码</div>
          <div class="card4">
            <div class="card4L">
              <div class="card4LItem">
                <div class="card4LItemTop">
                  {{ company.totalAuthNum || "0" }}
                </div>
                <div class="card4LItemBom">总授权数</div>
              </div>
              <div class="card4LItem">
                <div class="card4LItemTop">
                  {{ company.usedAuthNum || "0" }}
                </div>
                <div class="card4LItemBom">已用授权数</div>
              </div>
              <div class="card4LItem">
                <div class="card4LItemTop">
                  {{
                    (
                      (Number(company.totalAuthNum) || 0) -
                      (Number(company.usedAuthNum) || 0)
                    ).toFixed(0)
                  }}
                </div>
                <div class="card4LItemBom">未使用授权数</div>
              </div>
            </div>
            <!-- <div class="card4R">
              <div class="card4BtnL">查看激活码</div>
              <div class="card4BtnR">申请激活码</div>
            </div> -->
          </div>
        </template>

        <!-- 员工管理 -->
        <template v-if="activeMenu === MY_MENU.STAFF">
          <div class="card5">
            <div class="title">
              <div>员工管理</div>
              <div class="btn" @click="addUser">新增员工</div>
            </div>
            <div class="card5Card">
              <div
                class="card5CardItem"
                v-for="(item, index) in staffList"
                :key="index"
              >
                <div class="card5ItemTopBox">
                  <div class="card5ItemTopL">{{ item.username }}</div>
                  <div class="card5ItemTopR textOverflowOne">
                    {{ item.post }}
                  </div>
                </div>
                <div class="card5ItemBomBox">{{ item.phone }}</div>
                <!-- 审核中 -->
                <div v-if="item.state == 1" class="card5mask">审核中。。</div>
                <!-- 审核未通过 -->
                <div v-if="item.state == 3" class="card5maskFail">
                  <div class="card5maskFailText">
                    <div class="card5maskFailText1">审核未通过</div>
                    <div class="card5maskFailText2">{{ item.reason }}</div>
                  </div>
                  <div class="card5maskFailBtn" @click="uploadUser(item)">
                    修改
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- 消息通知 -->
        <message-notifications
          v-if="activeMenu === MY_MENU.NOTIFICATIONS"
          :company="company"
          @jump="changeMenu"
          @open-material="onClick"
        />
      </div>
    </div>
    <footers />

    <openCode ref="openCode" />

    <el-dialog
      title="新增员工"
      :visible.sync="dialogVisible"
      width="35%"
      :before-close="handleClose"
    >
      <el-form
        ref="userForm"
        :model="userForm"
        :rules="userFormRule"
        label-width="100px"
      >
        <el-form-item label="员工姓名" prop="username">
          <el-input
            class="input"
            placeholder="请输入员工姓名"
            maxlength="20"
            v-model="userForm.username"
          ></el-input>
        </el-form-item>
        <el-form-item label="员工岗位" prop="post">
          <el-input
            class="input"
            maxlength="20"
            placeholder="请输入员工岗位"
            v-model="userForm.post"
          ></el-input>
        </el-form-item>
        <el-form-item label="员工号码" prop="phone">
          <el-input
            class="input"
            placeholder="请输入员工手机号码"
            v-model="userForm.phone"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="Btn" type="primary" @click="sumbitUser"
          >提交审核</el-button
        >
      </span>
    </el-dialog>

    <contract-renew-modal
      :visible.sync="contractRenewVisible"
      :specialist-name="contractRenewSpecialist.name"
      :specialist-phone="contractRenewSpecialist.phone"
    />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import search from "@/components/search.vue";
import FormImgUpload from "@/components/formImgUpload";
import {
  userDetail,
  userCompany,
  userStaffList,
  userStaffAdd,
  userStaffUpdate,
  avatarUpdate,
  logOutapi,
  checkCompanyInfo,
  updateCompany,
} from "@/api/lx";
import { timeFormat } from "@/utils/index";
import L1 from "@/assets/images/L1.png";
import L2 from "@/assets/images/L2.png";
import L3 from "@/assets/images/L3.png";
import L4 from "@/assets/images/L4.png";
import openCode from "@/components/openCode.vue";
import CompanyInfoForm from "./compontents/CompanyInfoForm.vue";
import PerformanceInfo from "./compontents/PerformanceInfo.vue";
import ContractManagement from "./compontents/ContractManagement.vue";
import ContractRenewModal from "./compontents/ContractRenewModal.vue";
import MyAllies from "./compontents/MyAllies.vue";
import LicenseAccountApply from "./compontents/LicenseAccountApply.vue";
import MessageNotifications from "./compontents/MessageNotifications.vue";
import { MY_MENU, resolveMenuKey, getVisibleMenuItems, MY_MENU_ITEMS } from "./constants/menu";
export default {
  name: "Procucts",
  components: {
    headers,
    footers,
    search,
    FormImgUpload,
    openCode,
    CompanyInfoForm,
    PerformanceInfo,
    ContractManagement,
    ContractRenewModal,
    MyAllies,
    LicenseAccountApply,
    MessageNotifications,
  },
  data() {
    return {
      headPortrait: [],
      L1,
      L2,
      L3,
      L4,
      lenum: {
        L1: L1,
        L2: L2,
        L3: L3,
        L4: L4,
      },
      timeFormat,
      MY_MENU,
      activeMenu: MY_MENU.PROFILE,
      pendingMenuKey: null,
      dialogVisible: false,
      user: {
        type: 1,
      },
      company: {},
      staffList: [],
      userForm: {
        phone: "",
        post: "",
        username: "",
      },
      userFormRule: {
        phone: [
          { required: true, message: "请输入员工手机号码", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        username: [
          { required: true, message: "请输入员工姓名", trigger: "blur" },
        ],
        post: [{ required: true, message: "请输入员工岗位", trigger: "blur" }],
      },
      // userType:1,//1盘厂2业务员
      textShow: false,
      /** 标记当前用户企业/个人信息是否已完善，默认为已完善避免初始加载闪烁 */
      isCompleted: true,
      /** 合同续签弹窗是否显示 */
      contractRenewVisible: false,
      /** 续签弹窗授权专员联系方式（接口就绪后从 company / 合同详情赋值） */
      contractRenewSpecialist: {
        name: "",
        phone: "",
      },
      isEditForm: false,
      menuIcons: {
        [MY_MENU.PROFILE]: "el-icon-user",
        [MY_MENU.COMPANY]: "el-icon-office-building",
        [MY_MENU.STAFF]: "el-icon-s-custom",
        [MY_MENU.NOTIFICATIONS]: "el-icon-bell",
        [MY_MENU.PERFORMANCE]: "el-icon-data-line",
        [MY_MENU.CONTRACT]: "el-icon-document",
        [MY_MENU.ALLIES]: "el-icon-connection",
        [MY_MENU.LICENSE_APPLY]: "el-icon-edit-outline",
        [MY_MENU.CERTIFICATE]: "el-icon-medal",
        [MY_MENU.LICENSE]: "el-icon-key",
      },
    };
  },
  created() {
    const routeAct = this.$route && this.$route.query && this.$route.query.act;
    if (routeAct !== undefined && routeAct !== null && routeAct !== "") {
      this.pendingMenuKey = resolveMenuKey(routeAct);
    }
    const routeMode =
      this.$route && this.$route.query && this.$route.query.mode;
    if (routeMode === "edit") {
      this.isEditForm = true;
    }
    this.getUser();
    // 首次进入个人中心时，通过接口实时校验个人/企业信息是否已完善。若未完善，则强制定位至“完善企业信息”表单 tab
    checkCompanyInfo({}).then((res) => {
      this.isCompleted = res && res.data === true;
      if (!this.isCompleted) {
        this.activeMenu = MY_MENU.COMPANY;
      }
    });
    this.$root.$on("refreshUserInfo", this.getUser);
  },
  beforeDestroy() {
    this.$root.$off("refreshUserInfo", this.getUser);
  },
  mounted() {},
  watch: {
    $route(to) {
      const routeAct = to.query && to.query.act;
      if (routeAct !== undefined && routeAct !== null && routeAct !== "") {
        const key = resolveMenuKey(routeAct);
        this.changeMenu(key);
      }
      const routeMode = to.query && to.query.mode;
      if (routeMode === "edit") {
        this.isEditForm = true;
      } else {
        this.isEditForm = false;
      }
    },
  },
  computed: {
    equityLevelList() {
      const list =
        this.company && Array.isArray(this.company.equityClassifyList)
          ? this.company.equityClassifyList
          : [];
      return list;
    },
    /** 当前用户可见的左侧菜单项（展示所有菜单，包括无权限菜单；如果是盘厂用户，不展示“我的盟友”菜单） */
    visibleMenuList() {
      if (this.user && this.user.type == 1) {
        return MY_MENU_ITEMS.filter((item) => item.key !== MY_MENU.ALLIES);
      }
      return MY_MENU_ITEMS;
    },
    visibleMenuKeys() {
      return this.visibleMenuList.map((item) => item.key);
    },
  },
  methods: {
    /** 应用路由或外部传入的菜单 key（需在用户类型加载后调用） */
    applyPendingMenu() {
      if (!this.pendingMenuKey) return;
      this.changeMenu(this.pendingMenuKey);
      this.pendingMenuKey = null;
    },

    onClick() {
      if (this.user.state == 2) {
        this.$router.push({
          name: "examinationIndex",
        });
      } else {
        this.$refs.openCode.openShow();
      }
    },
    handleMouseEnter() {
      this.textShow = true;
    },
    handleMouseOut() {
      this.textShow = false;
    },
    upload(e) {
      // https://l-xpert.obs.cn-southwest-2.myhuaweicloud.com/backstage/d1959eeb-ba8f-649f-251a-6c94e28bca3b.jpg
      console.log(e);
      avatarUpdate({
        avatarUrl: e,
      }).then((res) => {
        this.user.avatarUrl = e;
        this.$refs.headers.refresh();
        this.headPortrait = [];
      });
    },

    getUser() {
      userDetail({}).then((res) => {
        this.user = res.data;
        if (this.user.type == 1) {
          this.getUserCompany();
          this.getUserStaffList();
        }
        this.$nextTick(() => {
          this.applyPendingMenu();
        });
      });
    },
    formatTime(seconds, type) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      // const secs = seconds % 60;
      return type === 1
        ? hours.toString().padStart(2, "0")
        : minutes.toString().padStart(2, "0");
    },
    // 格式化到期时间
    formatExpireDate(endTime) {
      if (!endTime) return "--";
      const time = new Date(String(endTime).replace(/-/g, "/"));
      if (isNaN(time.getTime())) return endTime;
      const year = time.getFullYear();
      const month = String(time.getMonth() + 1).padStart(2, "0");
      const date = String(time.getDate()).padStart(2, "0");
      return `${year}-${month}-${date}`;
    },
    // 计算到期时间
    getDaysUntilExpire(endTime) {
      if (!endTime) return null;
      const end = new Date(String(endTime).replace(/-/g, "/"));
      if (isNaN(end.getTime())) return null;
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);
      return Math.ceil((end - now) / (24 * 60 * 60 * 1000));
    },
    // 获取合同到期状态
    getContractExpireStatus(item) {
      if (!item) return "normal";
      const days = this.getDaysUntilExpire(item.endTime);
      // 1. 如果后端明确返回已过期状态 (isExpire === 2)，直接判定为已过期
      if (item.isExpire == 2) {
        return "expired";
      }
      // 2. 如果后端返回未过期状态 (isExpire === 1)
      if (item.isExpire == 1) {
        if (days === null) return "normal";
        if (days < 0) return "expired"; // 安全兜底：如果天数已过期但 isExpire 为 1，依然显示已过期
        if (days <= 30) return "soon"; // 30天内（含30天）为即将到期，提示续签
        return "normal";
      }
      // 3. 兼容兜底：如果 isExpire 字段不存在或值异常，退化为仅通过天数计算判定
      if (days === null) return "normal";
      if (days < 0) return "expired";
      if (days <= 30) return "soon";
      return "normal";
    },
    // 续签合同（个人资料等级区 / 合同管理表格共用）
    onRenewContract(item) {
      this.openContractRenewModal(item);
    },
    /** 打开合同续签提示弹窗 */
    openContractRenewModal(context) {
      const company = this.company || {};
      this.contractRenewSpecialist = {
        name: company.lxPrincipal || "",
        phone: company.lxPrincipalPhone || "",
      };
      this.contractRenewVisible = true;
      console.log("renew contract preview:", context);
    },
    getUserCompany() {
      userCompany({}).then((res) => {
        this.company = res.data;
      });
    },
    getUserStaffList() {
      userStaffList({}).then((res) => {
        this.staffList = res.data;
      });
    },
    /**
     * 切换左侧菜单并拦截无权限访问
     * @param {string} menuKey - 使用 MY_MENU 中的枚举值，如 MY_MENU.COMPANY
     */
    changeMenu(menuKey) {
      const key = resolveMenuKey(menuKey);
      // 若信息未完善且试图切换到其他 tab（非完善信息 tab），则进行拦截并提示
      if (!this.isCompleted && key !== MY_MENU.COMPANY) {
        this.$message.warning("请先完善企业信息");
        this.activeMenu = MY_MENU.COMPANY;
        return;
      }
      // 校验浏览权限，若无权限则拦截切换并提示
      if (!this.checkPermission(key)) {
        this.$message.warning("暂无浏览权限");
        return;
      }
      if (this.visibleMenuKeys.includes(key)) {
        this.activeMenu = key;
        if (key !== MY_MENU.COMPANY) {
          this.isEditForm = false;
        }
        return;
      }
      this.activeMenu = MY_MENU.PROFILE;
    },
    /**
     * 校验当前登录用户是否有指定菜单的浏览权限
     * @param {string} menuKey - 菜单的 key，对应 MY_MENU 枚举值
     * @returns {boolean} 返回 true 表示有权限，返回 false 表示无权限
     */
    checkPermission(menuKey) {
      if (this.user.type != 1) {
        // 非盘厂用户（业务员等），仅允许访问：个人资料、消息通知、我的盟友
        const allowed = [
          MY_MENU.PROFILE,
          MY_MENU.NOTIFICATIONS,
          MY_MENU.ALLIES
        ];
        return allowed.includes(menuKey);
      } else {
        // 盘厂用户
        if (this.user.isPrincipal) {
          // 盘厂负责人，允许访问除了“我的盟友”之外的所有菜单
          const disallowed = [MY_MENU.ALLIES];
          return !disallowed.includes(menuKey);
        } else {
          // 盘厂普通员工，不允许访问：“业绩信息”、“授权协议”、“我的盟友”、“员工管理”
          const disallowed = [
            MY_MENU.PERFORMANCE,
            MY_MENU.CONTRACT,
            MY_MENU.ALLIES,
            MY_MENU.STAFF
          ];
          return !disallowed.includes(menuKey);
        }
      }
    },
    onCompanyFormSubmit(formData) {
      // 提交表单数据到后端以完善企业信息
      updateCompany(formData)
        .then((res) => {
          if (res.code == 200) {
            // 提交成功后标记为已完善，解除切换限制
            this.isCompleted = true;
            this.$message.success("保存成功");
            this.isEditForm = false;
            // 重新拉取最新的企业信息以更新页面展示数据
            this.getUserCompany();
          } else {
            this.$message.error(res.msg || "保存失败");
          }
        })
        .catch(() => {
          this.$message.error("保存失败，请稍后重试");
        });
    },
    /** 业绩信息-返利额确认回调（子组件触发，接口就绪后扩展） */
    onRebateConfirmed(payload) {
      console.log("rebate confirmed preview:", payload);
    },
    /** 合同管理-续签合同回调 */
    onContractRenew(row) {
      this.openContractRenewModal(row);
    },
    /** License 账号申请提交回调 */
    onLicenseApplySubmit(formData) {
      console.log("license apply submit preview:", formData);
    },
    toSolutionDetails() {
      this.$router.push({
        path: "/forum/details",
        query: { id: 123 },
      });
    },
    addUser() {
      this.userForm.id = null;
      this.dialogVisible = true;
    },
    uploadUser(item) {
      this.userForm = JSON.parse(JSON.stringify(item));
      this.dialogVisible = true;
    },
    handleClose() {
      this.$refs["userForm"].resetFields();
      this.dialogVisible = false;
    },
    sumbitUser() {
      this.$refs["userForm"].validate((valid) => {
        if (valid) {
          if (this.userForm.id) {
            userStaffUpdate(this.userForm).then(async (res) => {
              this.getUserStaffList();
              this.handleClose();
            });
          } else {
            userStaffAdd(this.userForm).then(async (res) => {
              this.getUserStaffList();
              this.handleClose();
            });
          }
        }
      });
    },
    uploadPwd() {
      this.$router.push({
        path: "/uploadPwd/index",
      });
    },
    loginOut() {
      logOutapi({}).then((res) => {
        if (res.code == 200) {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          this.$router.push({
            path: "/",
          });
        }
      });
    },
    //下载图片
    downloadImage(val) {
      const url = val;
      const link = document.createElement("a");
      link.href = url;
      link.download = "image.jpg"; // 设置下载的文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 1600px;
  margin: 0 auto;
  margin-top: 30px;
  background: #ffffff;
  padding: 40px 0;
  display: flex;
}
.menuList {
  width: 260px;
  cursor: pointer;
  box-sizing: border-box;
  padding: 0 12px 0 12px;
  flex-shrink: 0;

  // 顶部卡片样式 (装饰性 - Teal渐变)
  .top-card {
    background: linear-gradient(135deg, #00d8c3 0%, #00bfa5 100%);
    border-radius: 8px;
    padding: 24px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    box-shadow: 0 6px 16px rgba(0, 216, 195, 0.15);
    cursor: default;

    .icon-box {
      width: 52px;
      height: 52px;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px solid rgba(255, 255, 255, 0.3);
      margin-bottom: 12px;
      box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);

      i {
        font-size: 24px;
        color: #ffffff;
      }
    }

    .card-label {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      color: #ffffff;
      letter-spacing: 1.5px;
    }
  }

  // 菜单列表样式
  .menu-items {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 22, 26, 0.04);
    border: 1px solid #e6edf0;
    padding: 8px 0;

    .menuItem {
      height: 52px;
      padding: 0 20px;
      display: flex;
      align-items: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #525f66;
      border-left: 4px solid transparent;
      transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;

      i {
        font-size: 20px;
        margin-right: 12px;
        color: #829199;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      }

      span {
        line-height: 1;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      }

      // 菜单项间细微分割线
      &:not(:last-child)::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 20px;
        right: 20px;
        height: 1px;
        background-color: #f5f8fa;
      }

      &:hover {
        background: #f8fafc;
        color: #00d8c3;

        i {
          color: #00d8c3;
          transform: translateX(3px);
        }

        span {
          transform: translateX(3px);
        }
      }

      &.active {
        background: #e5fbf9;
        color: #00d8c3;
        font-weight: 600;
        border-left-color: #00d8c3;

        i {
          color: #00d8c3;
          font-size: 21px;
        }

        // 激活项隐藏下边框分割线以保证背景美观
        &::after {
          background-color: transparent;
        }
      }
    }
  }
}
.contentR {
  border-left: 1px solid #e6edf0;
  width: 100%;
  padding: 0 50px;
  min-height: 800px;
  // height: calc(100vh - 450px);
  box-sizing: border-box;
  position: relative;
  // overflow-y: auto;
  // overflow-x: hidden;
}
.uploadPwd {
  position: absolute;
  width: 96px;
  height: 32px;
  background: #ffffff;
  border-radius: 5px;
  border: 1px solid #ced9de;
  top: 7px;
  right: 50px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #525f66;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
  z-index: 100;
}
.loginOut {
  position: absolute;
  cursor: pointer;
  top: 53px;
  right: 50px;
  width: 96px;
  height: 32px;
  background: #ffffff;
  border-radius: 5px;
  border: 1px solid #d14d21;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #d14d21;
  line-height: 20px;
  text-align: center;
  line-height: 32px;
  z-index: 100;
}
.userInfo {
  display: flex;
  align-items: center;
  position: relative;
  .avatar {
    width: 78px;
    height: 78px;
    border-radius: 50%;
    position: relative;
    cursor: pointer;
    & img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    .userMask {
      display: none;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.1);
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
      text-align: center;
      line-height: 78px;
    }
    .FormImgUpload {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      z-index: 1000;
      width: 78px;
      height: 78px;
      border-radius: 50%;
      overflow: hidden;
      /deep/ .el-upload {
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        width: 100% !important;
        height: 100% !important;
        line-height: 78px !important;
      }
    }
  }
  .nameBox {
    display: flex;
    min-width: 200px;
    height: 78px;
    flex-direction: column;
    justify-content: center;
    margin-left: 18px;
    margin-right: 20px;
    .name {
      display: flex;
      align-items: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 22px;
      color: #00161a;
      div {
        padding: 0 16px;
        height: 26px;
        line-height: 26px;
        background: rgba(0, 216, 195, 0.1);
        border-radius: 17px;
        font-weight: 600;
        font-size: 16px;
        color: #00d8c3;
        margin-left: 10px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 220px;
      }
    }
    .tel {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #525f66;
      margin-top: 12px;
    }
  }
  .equityLevelList {
    // flex: 1;
    margin-left: 32px;
    width: 360px;
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    padding-top: 4px;
  }
  .equityLevelItem {
    display: flex;
    align-items: center;
    gap: 16px;
    & + .equityLevelItem {
      margin-top: 4px;
    }
  }
  .equityLevelIconCol {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 56px;
    flex-shrink: 0;
  }
  .equityLevelIconWrap {
    width: 56px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    position: relative;
    filter: drop-shadow(0 4px 8px rgba(0, 22, 26, 0.08));
  }
  .equityLevelIcon {
    width: 56px;
    height: 42px;
    object-fit: contain;
    object-position: center center;
    display: block;
    user-select: none;
    pointer-events: none;
  }
  .equityLevelIconText {
    font-family: PingFangSC, PingFang SC;
    font-weight: 700;
    font-size: 16px;
    color: #00d8c3;
    line-height: 42px;
  }
  .equityLevelIconWrap--L2 .equityLevelIconText {
    color: #e99f48;
  }
  .equityLevelIconWrap--expired {
    filter: grayscale(100%) !important; /* 使整个容器包括图片置灰 */
    opacity: 0.6 !important; /* 降低不透明度，呈现灰色暗淡效果 */
    .equityLevelIcon {
      filter: grayscale(100%) brightness(0.8) !important; /* 双重置灰并略微调暗图片 */
    }
    .equityLevelIconText {
      color: #aeb5ba !important;
    }
  }
  .equityLevelTimeline {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 10px 0 6px;
    box-sizing: border-box;
  }

  .equityLevelInfo {
    flex: 1;
    min-width: 0;
    padding-top: 8px;
  }
  .equityLevelDate {
    font-family: PingFangSC, PingFang SC;
    font-size: 16px;
    color: #525f66;
    line-height: 24px;
  }
  .equityLevelDateVal {
    font-weight: 600;
    color: #00161a;
  }
  .equityLevelWarn {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 8px;
  }
  .equityLevelWarnText {
    font-family: PingFangSC, PingFang SC;
    font-size: 14px;
    color: #d14d21;
    line-height: 20px;
  }
  .equityRenewBtn {
    padding: 6px 16px;
    border-color: #00d8c3;
    color: #00d8c3;
    background: #fff;
    border-radius: 4px;
    font-size: 14px;
    &:hover,
    &:focus {
      color: #0088c7;
      border-color: #0088c7;
      background: #f0f9ff;
    }
  }
}
.line {
  width: 100%;
  height: 1px;
  background: #e6edf0;
}
.card2 {
  width: 1095px;
  height: 137px;
  background-image: url("../../assets/images/myBj.png");
  background-size: 100% 100%;
  margin-top: 15px;
  padding: 46px 35px 22px 176px;
  box-sizing: border-box;
  position: relative;
  .card2Name {
    display: flex;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 22px;
    color: #00161a;
    margin-bottom: 17px;
    div {
      padding: 0 14px;
      height: 26px;
      line-height: 26px;
      background: #ffffff;
      border-radius: 17px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #d4892e;
      margin-left: 10px;
    }
  }
  .card2Carousel {
    height: 26px;
  }
  .dateBox {
    width: 400px;
    height: 26px;
    display: flex;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ff8422;
    div {
      padding: 0 14px;
      height: 26px;
      background: linear-gradient(180deg, #ffcd84 0%, #e99f48 100%);
      border-radius: 17px;
      border: 1px solid #ffffff;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 26px;
      margin-right: 10px;
    }
  }
  .card2Right {
    position: absolute;
    height: 64px;
    display: flex;
    align-items: center;
    bottom: 21px;
    right: 35px;
    img {
      width: 88px;
      height: 64px;
      margin-left: 10px;
    }
  }
}

.card3 {
  margin-top: 20px;
  .card3Tit {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 22px;
    color: #00161a;
  }
  .card3Box {
    display: flex;
    margin-top: 15px;
    .card3Item {
      width: 206px;
      margin-right: 30px;
      img {
        width: 206px;
        height: 280px;
      }
      .card3ItemBtn {
        width: 96px;
        height: 32px;
        background: #ffffff;
        border: 1px solid #ced9de;
        margin: 0 auto;
        margin-top: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #525f66;
        cursor: pointer;
        line-height: 20px;
        text-align: center;
        line-height: 32px;
      }
    }
  }
}
.card4Tit {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 22px;
  color: #00161a;
  line-height: 30px;
  margin-top: 30px;
}
.card4 {
  width: 100%;
  height: 98px;
  background: #ebfcfb;
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card4L {
  display: flex;
  padding: 0 40px 0 45px;
  box-sizing: border-box;
}
.card4LItem {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 50px;
  .card4LItemTop {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 22px;
    color: #00161a;
  }
  .card4LItemBom {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #829199;
    margin-top: 8px;
  }
}
.card4R {
  display: flex;
  margin-right: 40px;
  cursor: pointer;
  .card4BtnL {
    width: 96px;
    height: 32px;
    background: #ffffff;
    border: 1px solid #00d8c3;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #00d8c3;
    text-align: center;
    line-height: 32px;
  }
  .card4BtnR {
    width: 96px;
    height: 32px;
    background: #00d8c3;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    line-height: 32px;
    margin-left: 20px;
  }
}
.card5 {
  width: 100%;
  margin-top: 32px;
  .title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 22px;
    color: #00161a;
    .btn {
      width: 96px;
      height: 32px;
      background: #00d8c3;
      border: 1px solid #ced9de;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      line-height: 32px;
      cursor: pointer;
    }
  }
  .card5Card {
    width: 1295px;
    margin-top: 15px;
    display: flex;
    flex-wrap: wrap;
    .card5CardItem {
      width: 346px;
      height: 97px;
      background: #ffffff;
      border: 1px solid #ced9de;
      margin-right: 24px;
      position: relative;
      padding: 20px 25px;
      box-sizing: border-box;
      margin-bottom: 20px;
      .card5ItemTopBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .card5ItemTopL {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #00161a;
        }
        .card5ItemTopR {
          width: 83px;
          height: 28px;
          background: #e5fbf9;
          border-radius: 17px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #00d8c3;
          text-align: center;
          line-height: 28px;
        }
      }
      .card5ItemBomBox {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #829199;
        margin-top: 12px;
      }
      .card5mask {
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.8);
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 14px;
        color: #00d8c3;
      }
      .card5maskFail {
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.8);
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        display: flex;
        justify-content: space-between;
        padding: 20px 26px 25px 31px;
        box-sizing: border-box;
        .card5maskFailText1 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 14px;
          color: #d14d21;
        }
        .card5maskFailText2 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #d14d21;
          margin-top: 10px;
          width: 200px;
        }
        .card5maskFailBtn {
          width: 62px;
          min-width: 62px;
          height: 32px;
          background: #00d8c3;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          cursor: pointer;
          text-align: center;
          line-height: 32px;
        }
      }
    }
  }
}
.card6 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 41px;
  img {
    width: 220px;
    height: 160px;
    display: block;
  }
}
.input {
  width: 380px;
}
.Btn {
  width: 120px;
  height: 39px;
  margin-left: 200px;
  background: #00d8c3;
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  border: 1px solid #00d8c3;
  &.is-active,
  &:active {
    border: 1px solid #00d8c3; /* 更改为你想要的颜色 */
    outline: none; /* 移除默认的轮廓线 */
  }
}

.scroll {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 60px;
  .scrollDay {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #829199;
    line-height: 22px;
  }
  .scrollBox {
    .num {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 24px;
      color: #00161a;
      line-height: 33px;
      margin-right: 2px;
    }
    .numTips {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #00161a;
      line-height: 20px;
    }
  }
}

.ks {
  cursor: pointer;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #829199;
  img {
    width: 23px;
    height: 23px;
    margin-bottom: 4px;
  }
}
</style>
